module.exports = __webpack_public_path__ + "img/asus-G731.81f3cf3c.jpg";